// ----------------------------------------------------------------------
// <copyright file="Izenda.SourceDestination.jsx" company="Izenda">  Copyright
// (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS. </copyright>
// ----------------------------------------------------------------------

/**
 * SourceDestination component
 */
!(function () {
  "use strict";

  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var SourceTree = require('../SourceTree/Izenda.SourceTree');
  var DestinationGrid = require('./DestinationGrid/Izenda.DestinationGrid');
  var ReportContainer = require('./Report/Izenda.ReportContainer');
  var DataConnector = require('./DataConnector/Izenda.DataConnector');
  var DataModel = require('./DataModel/Izenda.DataModel');
  var Dashboard = require('./Dashboard/Izenda.Dashboard');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var classnames = require('classnames');
  var actions = require('./Izenda.SourceDestinationActions');
  var observer = require('mobx-react').observer;

  var SourceDestination = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired,
      item: React.PropTypes.object.isRequired
    },

    render: function () {
      var props = this.props;
      var store = this.props.store;
      var item = this.props.item;
      var localization = this.props.localization;

      return (
        <div className='izenda-sourceDestination'>
          <DataConnector workspaceDetail={item} />
          <DataModel store={store} workspaceDetail={item} />
          <Dashboard workspaceDetail={item} />
          <ReportContainer workspaceDetail={item} store={store} />
          <DestinationGrid store={store} />
        </div>
      );
    }
  });

  //module.exports = observer(connect(actions)(SourceDestination));
  module.exports = connect(actions)(SourceDestination);
} ());



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/SourceDestination/Izenda.SourceDestination.jsx